import React from "react"
import Navbar from "../../Common/Components/Navbar"
import Footer from "../../Common/Components/Footer"
import Sidebar from "../../Sidebar/Sidebar"
import MessageComp from "./Component/MessageComp"


const Message =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea" >
            <Sidebar />
            <MessageComp />
        </div>
        <Footer />
        </>
    )
}

export default Message